import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { kycService } from "../../services/api";

interface KycState {
  kyc: any | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: KycState = {
  kyc: null,
  isLoading: false,
  error: null,
};

export const submitKyc = createAsyncThunk(
  "kyc/submit",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      return await kycService.submitKyc(formData);
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to submit KYC"
      );
    }
  }
);

export const getKycStatus = createAsyncThunk(
  "kyc/status",
  async (_, { rejectWithValue }) => {
    try {
      return await kycService.getKycStatus();
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to get KYC status"
      );
    }
  }
);

const kycSlice = createSlice({
  name: "kyc",
  initialState,
  reducers: {
    clearKycError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitKyc.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(submitKyc.fulfilled, (state, action) => {
        state.isLoading = false;
        state.kyc = action.payload.kyc;
      })
      .addCase(submitKyc.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(getKycStatus.fulfilled, (state, action) => {
        state.kyc = action.payload;
      });
  },
});

export const { clearKycError } = kycSlice.actions;
export default kycSlice.reducer;
